import React from 'react'
import { shallow } from 'enzyme'

import HelpfulHint from '../../features/HelpfulHints/HelpfulHint'
import NotesUtil from '../../helpers/NotesUtil'

describe('HelpfulHint', () => {
  let wrapper, props, instance
  beforeEach(() => {
    props = {
      hint: {
        title: 'business_entity',
        helpfulHints: [
          {
            rid: 1,
            description: "Sample description <a href='www.google.com'>Testing</a>",
          },
        ]
      }
    },
    wrapper = shallow(<HelpfulHint {...props} />)
    instance = wrapper.instance()
  })

  describe('#anchorLinkListener', () => {
    it('should run function if a present', () => {
      const gotoTab = spyOn(NotesUtil, 'gotoTab')
      instance.anchorLinkListener({ target: { tagName: 'A' } })
      expect(gotoTab).toHaveBeenCalled()
    })
    it('should not run function if a not present', () => {
      const gotoTab = spyOn(NotesUtil, 'gotoTab')
      instance.anchorLinkListener({ target: { tagName: 'Li' } })
      expect(gotoTab).not.toHaveBeenCalled()
    })
  })

})